import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { sprayService } from '@iso/services';
import { TemplateModalWrapper } from './TemplateModals.styles';

const { TextArea } = Input;

const EditTemplateModal = ({ visible, onCancel, onSave, template }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && template) {
      form.setFieldsValue({
        name: template.template_name || template.job_name,
        description: template.template_description || ''
      });
    }
  }, [visible, template, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const updateData = {
        template_name: values.name,
        template_description: values.description
      };

      const response = await sprayService.updateTemplate(template.id, updateData);
      
      if (response && response.code === '0000') {
        message.success('Template updated successfully');
        onSave();
        form.resetFields();
      } else {
        message.error('Failed to update template');
      }
    } catch (error) {
      console.error('Error updating template:', error);
      message.error('Failed to update template');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <TemplateModalWrapper
      title="Edit Template"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} className="cancel-button">
          Cancel
        </Button>,
        <Button key="save" type="primary" loading={loading} onClick={handleSave} className="btn-success">
          Save
        </Button>
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Template name is required' }]}
        >
          <Input placeholder="Ex: Template N°1" />
        </Form.Item>
        
        <Form.Item
          name="description"
          label="Description"
        >
          <TextArea 
            placeholder="Enter description (optional)"
            rows={4}
          />
        </Form.Item>
      </Form>
    </TemplateModalWrapper>
  );
};

export default EditTemplateModal;